import secureApi from "../services/secureApi";

export const getFonts = async ({
  page = 1,
  limit = 10,
  search = "",
  sort = "desc",
} = {}) => {
  try {
    const params = {
      page,
      limit,
      sort,
    };

    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await secureApi.get("/admin/font/list", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching fonts:", error);
    return {
      data: [],
      pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
      },
    };
  }
};

export const getFontById = async (id) => {
  try {
    const response = await secureApi.get(`/admin/font/view/${id}`);
    return response.data;
  } catch (error) {
    console.error("GET FONT ERROR:", error);
    return null;
  }
};

export const addFont = async (data) => {
  try {
    const response = await secureApi.post("/admin-upload/font/add", data);
    return response.data;
  } catch (error) {
    console.error("ADD FONT ERROR:", error);
    throw error;
  }
};

export const editFont = async (id, data) => {
  try {
    const response = await secureApi.put(`/admin-upload/font/edit/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("EDIT FONT ERROR:", error);
    throw error;
  }
};

export const deleteFont = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/font/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("DELETE FONT ERROR:", error);
    throw error;
  }
};